import React from 'react';

export class NotFoundPage extends React.Component {

  render() {

    return (
      <div className="login-form">
        <div className="centered">Not Found</div>
        <p>The page you are trying to find does not exist anymore.</p>
      </div>
    );
  }
}
